export default class PondRippleEvent extends google.maps.OverlayView {
  constructor(opts) {
    super(opts)
    this.setValues(opts)
  }

  onRemove() {
    this.div.parentNode.removeChild(this.div)
  }

  remove() {
    this.setMap(null)
  }

  draw() {
    if (!this.div) {
      const panes = this.getPanes()
      this.div = document.createElement('div')
      // const customClass = ''
      // if (this.showEntityType) {
      //   customClass = 'showEntityType'
      // }
      this.div.innerHTML = `<div class="circleEvent" style="animation-delay: -9s"></div>
                              <div class="circleEvent" style="animation-delay: -6s"></div>
                              <div class="circleEvent" style="animation-delay: 0s"></div>`
      this.div.style.position = 'absolute'
      panes.overlayLayer.appendChild(this.div)
    }
    setTimeout(() => this.remove(), 10000)
    const point = this.getProjection().fromLatLngToDivPixel(this.position)
    if (point) {
      this.div.style.left = point.x + 'px'
      this.div.style.top = point.y + 'px'
    }
  }
}
